import brands from "./brands";
import categories from "./categories";
import products from "./products";
import giftcards from "./giftcards";
import orders from "./orders";

export default {
    brands,
    categories,
    products,
    giftcards,
    orders,
}
